<template>
  <v-app id="inspire">
    <div>
      <v-content>
        <v-container>
          <div class="mt-10">
            <v-row class="justify-center">
              <div class="col-12">
                <v-row class="justify-center mb-10">
                  <div class="text-center">
                    <p class="display-1 font-weight-bold mb-0">SHOP+</p>
                    <p>Success online partner</p>
                  </div>
                </v-row>
                <FindId v-if="pageType == 'findId'" ref="FindId"></FindId>
                <FindPassword
                  v-else-if="pageType == 'findPassword'"
                  ref="FindPassword"
                ></FindPassword>
                <PassWordReSet
                  v-else-if="pageType == 'passWordReSet'"
                  ref="PassWordReSet"
                ></PassWordReSet>
                <SignUpMembership
                  v-else-if="pageType == 'signUpMembership'"
                  ref="SignUpMembership"
                ></SignUpMembership>
                <Login v-else ref="Login"></Login>
              </div>
            </v-row>
          </div>
        </v-container>
      </v-content>
    </div>
  </v-app>
</template>

<style scoped>
.navigation-router-link {
  color: unset;
  text-decoration: none;
  width: 100%;
  display: flex;
}
</style>

<script>
import store from "../../../store";
import M from "@/libs/mapping.js";
import Login from "@/components/shoplus_service/partners/Login.vue";
import FindId from "@/components/shoplus_service/partners/FindId.vue";
import FindPassword from "@/components/shoplus_service/partners/FindPassword.vue";
import PassWordReSet from "@/components/shoplus_service/partners/PassWordReSet.vue";
import SignUpMembership from "@/components/shoplus_service/partners/SignUpMembership.vue";

export default {
  data() {
    return {
      M,
      appTitle: "Shop+ 서비스",
      mallId: null,
      pageType: null
    };
  },
  methods: {
    setMallId: function() {
      this.mallId = store.state.mallId;
    },
    urlSplit: function() {
      let url = this.$router.app.path;
      let pathArray = url.split("/");
      if (pathArray[2]) {
        this.pageType = pathArray[2];
      }
    }
  },
  components: {
    Login,
    FindId,
    FindPassword,
    PassWordReSet,
    SignUpMembership
  },
  created: async function() {
    this.setMallId();
    this.urlSplit();
    if (this.mallId) {
      try {
        let result = await M.api(M.entry("/users/info"));
        this.$refs.AppVersion.setInfoParams(result);
      } catch (e) {
        alert("업체 정보 조회에 실패했습니다.");
      }
    }
  }
};
</script>

